import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './EventInfoModal.module.scss';
import calendarIcon from '../../../assets/Imagess/calendar-black.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import he from 'he';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

const NewsletterInfoModal = ({ news, handleOnClose, setShowDeletePopup }) => {
  const navigate = useNavigate();

  const decodedHTML = news ? he.decode(news?.body_AR) : '';

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px', gap: '0px' }}
    >
      <div>
        <img
          src={sanitizeAndValidateUrl(`${news?.url}${news?.newsletterImage}`)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['modal-image']}
        />
      </div>
      <div className={styles['title-container']}>
        <p className={styles['title']}>{news?.title_AR}</p>
      </div>
      <div className={styles['info-container']}>
        <p className={styles['category-name']}>{news?.category_AR}</p>
        <div className={styles['date-time-container']}>
          <div className={styles['date-time-item']}>
            <p>{moment(news?.newsletterDate).format('DD/MM/yyyy')}</p>
            <img src={calendarIcon} />
          </div>
        </div>
        <div className={styles['text-container']}>
          <div className={styles['description']}>
            <p
              className={styles['text']}
              dangerouslySetInnerHTML={{ __html: decodedHTML }}
            />
          </div>
        </div>
        <div className={styles['button-container']}>
          <Buttons
            text="تعديل"
            color="#0DA06E"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() =>
              navigate(`/home/edit-newsletters/${news?.eventId}`)
            }
          />
          <Buttons
            text="حذف"
            color="#D72222"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              handleOnClose();
              setShowDeletePopup(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default NewsletterInfoModal;
